import * as React from 'react';
import { Geolocation, PermissionStatus } from '@capacitor/geolocation';
import { Capacitor } from '@capacitor/core';

const log = false;

export default function useGeolocation() {
  const [position, setPosition] = React.useState<GeolocationPosition['coords'] | null>(null);
  const [permission, setPermission] = React.useState<PermissionStatus['location'] | null>(null);
  const [error, setError] = React.useState<string | null>(null);

  React.useEffect(() => {
    const request = async () => {
      try {
        if (!Capacitor.isNativePlatform()) {
          return;
        }

        const perm = await Geolocation.requestPermissions();
        setPermission(perm.location);

        if (perm.location === 'granted') {
          const coords = await Geolocation.getCurrentPosition();
          setPosition(coords.coords as GeolocationCoordinates);
        } else {
          setError('Permission not granted');
        }
      } catch (err) {
        setError((err as Error).message);
      }
    };

    request();
  }, []);

  React.useEffect(() => {
    if (import.meta.env.DEV && log) {
      console.log(`[{useGeolocation}]:`, {
        position,
        permission,
        error,
        isNative: Capacitor.isNativePlatform(),
      });
    }
  }, [position, permission, error]);

  return { position, error, permission };
}
